import { render, staticRenderFns } from "./IM_2_0.vue?vue&type=template&id=e0c364a8&scoped=true&"
import script from "./IM_2_0.vue?vue&type=script&lang=js&"
export * from "./IM_2_0.vue?vue&type=script&lang=js&"
import style0 from "./IM_2_0.vue?vue&type=style&index=0&id=e0c364a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c364a8",
  null
  
)

export default component.exports